<template>
  <v-row class="pb-5" v-scroll="onScroll">
    <!-- header -->
    <mini-header :breadcrumbs="breadcrumbs" :hiddenTab="true" :dense="true" :scroll="scroll">
      <template v-slot:main>
        <v-autocomplete v-model="selected.branch" label="Selecciona una tienda" :items="branchList" item-value="branch_id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition', maxWidth: '300px' }" height="40" single-line outlined dense hide-details no-data-text="No hay tiendas" append-icon="mdi-chevron-down"></v-autocomplete>
        <v-spacer />
        <!-- <v-btn class="mr-2" color="blue-500" @click="updatedView" outlined>
          <v-img contain :src="require(`@/assets/icon-update${$vuetify.theme.dark ? '-dark' : ''}.svg`)" />
        </v-btn> -->
        <v-menu close-on-click close-on-content-click offset-y left :nudge-bottom="10" transition="slide-y-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ml-2" color="blue-500" :height="40" v-bind="attrs" v-on="on">
              <v-icon left>mdi-calendar-blank </v-icon>{{filter[selected.q] ?? 'Fecha'}}<v-icon size="18" right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list class="pa-0">
            <v-list-item class="px-3" @click="selected.q = 'this_day'" :ripple="false">
              <v-list-item-title class="body-2 grey-500--text">Hoy</v-list-item-title>
            </v-list-item>
            <v-list-item class="px-3" @click="selected.q = 'last_day'" :ripple="false">
              <v-list-item-title class="body-2 grey-500--text">Ayer</v-list-item-title>
            </v-list-item>
            <v-list-item class="px-3" @click="selected.q = 'this_week'" :ripple="false">
              <v-list-item-title class="body-2 grey-500--text">Esta semana</v-list-item-title>
            </v-list-item>
            <v-list-item class="px-3" @click="selected.q = 'last_week'" :ripple="false">
              <v-list-item-title class="body-2 grey-500--text">Semana pasada</v-list-item-title>
            </v-list-item>
            <v-list-item class="px-3" @click="selected.q = 'this_month'" :ripple="false">
              <v-list-item-title class="body-2 grey-500--text">Este mes</v-list-item-title>
            </v-list-item>
            <v-list-item class="px-3" @click="selected.q = 'last_month'" :ripple="false">
              <v-list-item-title class="body-2 grey-500--text">Mes pasado</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </mini-header>
    <!-- end header -->
    <template v-if="loading">
      <v-col cols="12" class="pa-0">
        <v-row class="mt-5 px-1" >
          <v-col cols="4" class="pa-0" v-for="item in 3" :key="item">
            <v-skeleton-loader class="mt-n3 pa-2"
            style="border-radius: 10px !important;" transition="fade-transition" type="list-item-two-line"/>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="mt-10 pa-0">
        <v-row class="px-1">
          <v-col cols="6" class="pa-0" v-for="item in 2" :key="item">
            <v-skeleton-loader class="mt-n3 pa-2"
            style="border-radius: 10px !important;" transition="fade-transition" type="image"/>
          </v-col>
        </v-row>
      </v-col>
    </template>

    <template v-else>
      <v-col cols="12" v-if="!hasData">
        <empty-state class="mt-10" type="metrics-branch" id="metrics" :height="320" title="¿Quieres ver el monitor?" description="Filtra para obtener registros" :hiddenDescription="true" :isFree="true" />
      </v-col>
      <v-col class="pa-0" v-else>
        <v-row class="px-1 mt-4">
          <v-col cols="4" class="py-0 px-2">
            <v-card class="pa-4 rounded-md" flat>
              <span class="text-subtitle-2 grey-700--text font-weight-bold">Total de ventas</span>
              <span class="d-block mt-2 font-weight-bold text-h4 grey-700--text">
                {{$store?.state?.auth?.account?.country === 'PE' ? 'S./' : currencyCL}} {{ formatNumber2(summary.total_sales, this.$store.state.auth.account.currency !== 'CLP') }}
              </span>
            </v-card>
          </v-col>
          <v-col cols="4" class="py-0 px-2">
            <v-card class="pa-4 rounded-md" flat>
              <span class="text-subtitle-2 grey-700--text font-weight-bold">Q Tickets</span>
              <span class="d-block mt-2 font-weight-bold text-h4 grey-700--text">
                {{ formatNumber2(summary.total_tickets, false) }}
              </span>
            </v-card>
          </v-col>
          <v-col cols="4" class="py-0 px-2">
            <v-card class="pa-4 rounded-md" flat>
              <span class="text-subtitle-2 grey-700--text font-weight-bold">Ticket promedio</span>
              <span class="d-block mt-2 font-weight-bold text-h4 grey-700--text">
                {{$store?.state?.auth?.account?.country === 'PE' ? 'S./' : currencyCL}} {{ formatNumber2(summary.average_ticket, this.$store.state.auth.account.currency !== 'CLP') }}
              </span>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="mt-8 px-1">
          <v-col cols="6" class="py-0 px-2">
            <v-card flat class="d-flex flex-column">
              <v-card-title class="pt-3 px-0">
                <v-toolbar color="transparent" flat height="46">
                  <v-toolbar-title class="px-5 d-flex align-center subtitle-2 grey-500--text font-weight-semibold">Ventas</v-toolbar-title>
                  <v-spacer />
                  <div class="d-flex pr-5">
                    <v-sheet class="d-flex mr-4 ml-1 rounded-sm" width="7" height="14" color="blue-500" />
                    <span class="body-2 grey-500--text ml-n2">Total de ventas</span>
                  </div>
                </v-toolbar>
              </v-card-title>
              <v-card-text class="pb-4 flex-grow-1">
                  <chart-line :chart-data="salesChart" :show-legend="false" :month-label="salesMonth" :show-point="false"
                  :height="chartHeight" :key="`line-${chartHeight}`" />
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" class="py-0 px-2">
            <v-card flat class="d-flex flex-column">
              <v-card-title class="pt-3 px-0">
                <v-toolbar color="transparent" flat height="46">
                  <v-toolbar-title class="px-5 d-flex align-center subtitle-2 grey-500--text font-weight-semibold">Q-Promedio por ticket</v-toolbar-title>
                  <v-spacer />
                  <div class="d-flex pr-5">
                    <div class="d-flex">
                      <v-sheet class="d-flex mr-4 ml-1 rounded-sm" width="7" height="14" color="blue-100" />
                      <span class="body-2 grey-500--text ml-n2">Q de ticket</span>
                    </div>
                    <div class="d-flex ml-5">
                      <v-sheet class="d-flex mr-4 ml-1 rounded-sm" width="7" height="14" color="blue-500" />
                      <span class="body-2 grey-500--text ml-n2">Promedio de ventas</span>
                    </div>
                  </div>
                </v-toolbar>
              </v-card-title>
              <v-card-text class="pb-4 flex-grow-1">
                <chart-bar-line :chart-data="avgTicketChart" :x-axis-label="salesMonth" :show-legend="false" x-axis-type="date" :height="chartHeight" :key="`bar-line-${chartHeight}`" />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-card class="mt-8 d-flex flex-column" flat>
          <v-card-title class="pt-3 px-0">
            <v-toolbar color="transparent" flat height="46">
              <v-toolbar-title class="px-5 d-flex align-center subtitle-2 grey-500--text font-weight-semibold">Q-Promedio por caja</v-toolbar-title>
            </v-toolbar>
          </v-card-title>
          <v-card-text class="pa-4 flex-grow-1">
            <div class="d-flex align-center fill-height">
              <div class="pr-0" style="min-width: 180px;">
                <div class="d-flex align-end">
                  <v-sheet class="d-flex mr-4 ml-1 rounded-sm" width="7" height="14" color="blue-100" />
                  <span class="body-2 grey-500--text ml-n2" style="position: relative; top: 3px;">Q de ticket</span>
                </div>
                <div class="d-flex align-end mt-3">
                  <v-sheet class="d-flex mr-4 ml-1 rounded-sm" width="7" height="14" color="blue-500" />
                  <span class="body-2 grey-500--text ml-n2" style="position: relative; top: 3px;">Promedio de ventas</span>
                </div>
              </div>
              <div class="flex-grow-1" style="width: calc(100% - 180px);">
                <chart-bar-line :chart-data="avgCashChart" x-axis-label="Cajas" :show-legend="false" x-axis-type="category" :height="chartHeight" :key="`bar-cash-${chartHeight}`" />
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>
<script>
import MiniHeader from '@/components/commons/MiniHeader'
import ListViewMixin from '@/mixins/ListViewMixin'
import ChartBarLine from '@/components/charts/ChartBarLine'
import ChartLine from '@/components/charts/ChartLine'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import EmptyState from '@/components/commons/VEmptyState'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  components: {
    MiniHeader,
    ChartBarLine,
    ChartLine,
    EmptyState
  },
  mixins: [
    ListViewMixin,
    GenericViewMixin
  ],
  data: () => ({
    selected: {
      q: '',
      branch: null
    },
    filter: {
      this_day: 'Hoy',
      last_day: 'Ayer',
      this_week: 'Esta semana',
      last_week: 'Semana pasada',
      this_month: 'Este mes',
      last_month: 'Mes pasado'
    },
    summary: {},
    salesChart: {
      labels: [],
      datasets: [
        {
          label: 'Promedio de ventas',
          borderColor: '#0352cc',
          backgroundColor: 'rgba(36, 102, 203, 0.1)',
          data: [],
          type: 'line',
          fill: true,
          lineTension: 0.4
        }
      ]
    },
    avgTicketChart: {
      labels: [],
      datasets: [
        {
          label: 'Q de ticket',
          backgroundColor: '#b1c9ef',
          data: [],
          yAxisID: 'left-y-axis',
          type: 'bar'
        },
        {
          label: 'Promedio de ventas',
          borderColor: '#0352cc',
          backgroundColor: 'rgba(36, 102, 203, 0.1)',
          data: [],
          type: 'line',
          fill: false,
          borderWidth: 2,
          yAxisID: 'right-y-axis',
          lineTension: 0.4
        }
      ]
    },
    avgCashChart: {
      labels: [],
      datasets: [
        {
          label: 'Q de ticket',
          backgroundColor: '#b1c9ef',
          data: [],
          yAxisID: 'left-y-axis',
          type: 'bar'
        },
        {
          label: 'Promedio de ventas',
          borderColor: '#0352cc',
          data: [],
          type: 'line',
          fill: false,
          borderWidth: 2,
          yAxisID: 'right-y-axis',
          lineTension: 0.4
        }
      ]
    },
    salesMonth: '',
    hasData: false,
    scroll: 0,
    loading: false,
    reset: 0,
    windowHeight: 0
  }),
  computed: {
    ...mapState({
      countriesList: state => state.base.countriesList,
      branchList: state => state.branches.branchesList
    }),
    breadcrumbs () {
      return {
        main: 'Métricas',
        children: [
          { text: 'Ventas por tienda' }
        ]
      }
    },
    chartHeight () {
      const calculatedHeight = (this.windowHeight - 490) / 2
      return calculatedHeight > 100 ? calculatedHeight : 100
    },
    currencyCL () {
      return this.$store.state.auth.account.currency === 'CLP' ? 'CLP' : '$'
    }
  },
  watch: {
    '$route' () {
      this.updatedView()
    },
    selected: {
      handler (val) {
        if (val.q && val.branch) {
          this.$router.replace({ query: { q: val.q, branch: val.branch } }).catch(() => {})
        }
      },
      deep: true
    }
  },
  created () {
    if (this.$route.query.q) this.selected.q = this.$route.query.q
    if (this.$route.query.branch) this.selected.branch = this.$route.query.branch
    this.updatedView()
    window.addEventListener('resize', this.onResize)
  },
  mounted () {
    this.$nextTick(() => {
      this.onResize()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize () {
      this.windowHeight = window.innerHeight
    },
    onScroll (e) {
      this.offsetTop = e.target?.scrollingElement?.scrollTop ?? 0
    },
    async getBranchList () {
      await this.$store.dispatch('branches/LIST', {
        resource: 'pos-app/branches'
      })
    },
    async updatedView () {
      await this.getBranchList()
      this.getData()
    },
    getData () {
      this.loading = true
      this.hasData = false
      this.salesMonth = ''
      this.summary = {}
      this.salesChart.labels = []
      this.salesChart.datasets[0].data = []
      this.avgTicketChart.labels = []
      this.avgTicketChart.datasets[0].data = []
      this.avgTicketChart.datasets[1].data = []
      this.avgCashChart.labels = []
      this.avgCashChart.datasets[0].data = []
      this.avgCashChart.datasets[1].data = []

      if (this.selected.branch && !this.branchList.some(b => b.branch_id === this.selected.branch)) {
        this.selected.branch = null
      }

      if (!this.selected.branch && this.branchList.length > 0) {
        this.selected.branch = this.branchList[0].branch_id
      }

      if (!this.selected.branch) {
        this.loading = false
        return
      }

      const period = this.selected.q || 'this_month'
      let query = JSON.parse(JSON.stringify(this.$route.query))
      delete query.branch
      delete query.q

      const requestByDay = this.$store.dispatch('branches/GET', {
        resource: `metrics/branches/${this.selected.branch}/by-day/${period}`,
        query: {
          ...query,
          ...(this.$store.state.auth.account.currency && { currency: this.$store.state.auth.account.currency }),
          ...(this.$store.state.auth.account.time_zone && { timezone: this.$store.state.auth.account.time_zone })
        }
      })

      const requestAmounts = this.$store.dispatch('branches/GET', {
        resource: `metrics/branches/${this.selected.branch}/amounts/${period}`,
        query: {
          ...query,
          ...(this.$store.state.auth.account.currency && { currency: this.$store.state.auth.account.currency }),
          ...(this.$store.state.auth.account.time_zone && { timezone: this.$store.state.auth.account.time_zone })
        }
      })

      Promise.all([requestByDay, requestAmounts])
        .then(([byDayResponse, amountsResponse]) => {
          // Process daily data for the top two charts
          const dailyData = byDayResponse.data
          const dates = Object.keys(dailyData).sort()
          const { list_cpos: listCpos, ...summary } = amountsResponse.data

          if (dates.length > 0 || (listCpos && listCpos.length > 0)) {
            this.hasData = true
          }

          if (dates.length > 0) {
            const monthName = moment(dates[0]).format('MMMM')
            this.salesMonth = monthName.charAt(0).toUpperCase() + monthName.slice(1)

            const salesByDay = []
            const countByDay = []
            const avgAmountByDay = []

            dates.forEach(date => {
              const dayData = dailyData[date]
              salesByDay.push(dayData.amount_total)
              countByDay.push(dayData.count)
              avgAmountByDay.push(dayData.amount_avg)
            })

            // Ventas Chart
            this.salesChart.labels = dates
            this.salesChart.datasets[0].data = salesByDay

            // Q-Promedio por ticket Chart
            this.avgTicketChart.labels = dates
            this.avgTicketChart.datasets[0].data = countByDay
            this.avgTicketChart.datasets[1].data = avgAmountByDay
          }

          // Process amounts data for summary cards and bottom chart
          this.summary = {
            total_sales: summary.amount_total,
            total_tickets: summary.count,
            average_ticket: summary.amount_avg
          }

          if (listCpos && listCpos.length > 0) {
            const cashLabels = listCpos.map(c => c.id)
            const cashCountData = listCpos.map(c => c.count)
            const cashAvgData = listCpos.map(c => c.amount_avg)

            this.avgCashChart.labels = cashLabels
            this.avgCashChart.datasets[0].data = cashCountData
            this.avgCashChart.datasets[1].data = cashAvgData
          }
        })
        .catch(() => {
          this.hasData = false
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss">
.v-skeleton-loader .v-skeleton-loader__list-item, .v-skeleton-loader .v-skeleton-loader__list-item-avatar, .v-skeleton-loader .v-skeleton-loader__list-item-text, .v-skeleton-loader .v-skeleton-loader__list-item-two-line, .v-skeleton-loader .v-skeleton-loader__list-item-avatar-two-line, .v-skeleton-loader .v-skeleton-loader__list-item-three-line, .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line {
    border-radius: 10px;
}
</style>
